<template>
  <ConfirmationModal
    bodyText=""
    :cancelText="cancelText"
    :continueText="continueText"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    headerText="Force Password Change"
    :kbLink="$options.kbLink"
    :mainActionAttention="mainActionAttention"
    :mdTemplate="bodyText"
    :showClose="true"
  >
    <template v-slot:message>
      <MessageContainer
        v-if="infoText"
        :level="$options.info"
      >
        {{ infoText }}
      </MessageContainer>
    </template>
    <div v-if="cancelText">
      <br v-if="bodyText">
      <p>
        <strong>Are you sure</strong> you want to force {{ userText }}
        to change their {{ passwordText }}<span v-if="loginChange"> at logon</span>?
        This immediately expires their {{ passwordText }}.
      </p>
      <p>
        Some things to keep in mind:
      </p>
      <ul>
        <li v-if="loginChange">
          Users must change their password before they can access their device and resources.
        </li>
        <li v-else>
          Users are logged out of all JumpCloud managed resources immediately.
        </li>
        <br>
        <li>Make sure your password configurations for password expiration are set correctly.</li>
      </ul>
    </div>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from 'components/Modal/ModalComponents/ConfirmationModal.vue';
import Constants from 'client/util/Constants';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import MessageContainer from 'components/MessageContainer/MessageContainer.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import pluralize from 'pluralize';

const { info } = Constants;

export default {
  name: 'ForcePasswordChangeModal',

  components: {
    ConfirmationModal,
    MessageContainer,
  },

  props: {
    bodyText: {
      type: String,
      default: '',
    },

    cancelText: {
      type: String,
      default: 'cancel',
    },

    continueText: {
      type: String,
      default: 'force change',
    },

    handleCancel: {
      type: Function,
      default: () => ModalEventBus.close(),
    },

    handleContinue: {
      type: Function,
      default: () => ModalEventBus.close(),
    },

    infoText: {
      type: String,
      default: '',
    },

    loginChange: Boolean,

    mainActionAttention: {
      type: Boolean,
      default: true,
    },

    plural: Boolean,

  },

  computed: {
    passwordText() {
      return this.plural ? pluralize.plural('password') : 'password';
    },
    userText() {
      return this.plural ? `${pluralize.plural('this')} ${pluralize.plural('user')}` : 'this user';
    },
  },

  info,

  kbLink: KbArticleUrls.passwordExpirationStrategy,
};
</script>
